var React = require('react');

function Chevron (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M12.4493 10.5L6.22461 4.27524L7.10849 3.39136L14.2171 10.5L7.10849 17.6086L6.22461 16.7247L12.4493 10.5Z","fill":"white"}));
}

Chevron.defaultProps = {"width":"20","height":"21","viewBox":"0 0 20 21","fill":"none"};

module.exports = Chevron;

Chevron.default = Chevron;
